module.exports = __webpack_public_path__ + "img/mubanditui.42b1f3d5.png";